import {Component, input, Input, OnDestroy, OnInit, output} from '@angular/core';
import {MENU_ITEMS_CONSTANTS} from '../../../../core/constants/menu.constants';
import {TBaseCommonComponent} from '../../../../shared/components/base-components/t-base-common.component';
import {CommonService} from '../../../../shared/services/common.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent extends TBaseCommonComponent implements OnInit, OnDestroy {
  constructor(
  ) {
    super();
  }

  isSidebarOpenInput = input.required<boolean>();
  toggleSidebarOutput = output<any>();

  protected readonly MENU_ITEMS_CONSTANTS = MENU_ITEMS_CONSTANTS;
  activeRoute: string = "";

  isActiveRoute(route: string): boolean {
    const formattedRoute = route.startsWith('/') ? route : '/' + route;
    return this.activeRoute.startsWith(formattedRoute);
  }


  ngOnInit(): void {
    this.activeRoute = this.router.url;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.activeRoute = event.urlAfterRedirects;
      });
  }

  ngOnDestroy(): void {
  }

  internalNavigateTo(route: any) {
    if (this.isSidebarOpenInput()) {
      this.toggleSidebarOutput.emit(null);
    }

    this.navigateTo(route);
  }
}
